import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/widgets/common/Modal.vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { useAccountContext } from "@/hooks/useAccountContext"
import { useMissionLifecycleContext } from "@/modules/Missions/hooks/useMissionLifecycleContext"
import TextInput from "@/ui/TextInput/TextInput.vue"
import { ref } from "vue"
import MissionStateSwitcher from "./MissionStateSwitcher.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MissionToolbar',
  props: {
    title: null,
    link: null,
    state: null,
    missionLifecycleId: null
  },
  setup(__props: any) {

const props = __props as {
  title: string
  link: string
  state: string
  missionLifecycleId?: string
}



const missionName = ref(props.title)

const showLinkDialog = ref(false)
const showEditMissionNameModal = ref(false)

const { isStaff } = useAccountContext()
const { updateMissionLifecycle, isLoading } = useMissionLifecycleContext()

const saveMissionName = async () => {
  await updateMissionLifecycle({
    updateInput: { name: missionName.value },
    onSuccess: () => {
      showEditMissionNameModal.value = false
    },
  })
}

const onEditMissionName = () => {
  if (!isStaff) return
  showEditMissionNameModal.value = true
}

return { __sfc: true,props, missionName, showLinkDialog, showEditMissionNameModal, isStaff, updateMissionLifecycle, isLoading, saveMissionName, onEditMissionName, Modal, Icon, TextInput, MissionStateSwitcher }
}

})